import { StyledInput } from 'styles/v2/Styles.styled';

import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import Tooltip from 'components/controls/Tooltip';
import { useId } from 'react';

type TProps = Partial<TSmartLabelProps> & {
  value: any;
  name: string;
  onChanged?(name: string, value: string): void;
  disabled?: boolean;
  style?: any;
  placeholder?: string;
  type?: string;
  containerClassName?: string;
  multiline?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;
const WizardTextInputComponent: React.FunctionComponent<TProps> = ({
  label,
  tooltip,
  tooltipPosition,
  labelStyle,
  name,
  value,
  onChanged,
  disabled,
  style,
  placeholder,
  type,
  required,
  error,
  containerClassName,
  title,
  id,
  multiline,
  ...props
}) => {
  const fallbackInputId = useId();
  const inputId = id || fallbackInputId;
  const isReadOnly = useIsReadOnlyMode() || disabled;
  return (
    <div className={containerClassName} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          hasValue={value !== null && value !== undefined && value !== ''}
          error={error}
        />
      )}
      <StyledInput
        {...props}
        as={(multiline ? 'textarea' : undefined) as undefined}
        id={inputId}
        style={style}
        type={type}
        defaultValue={value}
        onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
          e.currentTarget.value !== value?.toString() && onChanged?.(name, e.currentTarget.value);
        }}
        disabled={isReadOnly}
        placeholder={isReadOnly ? undefined : placeholder}
      />
      {title && (
        <Tooltip targetId={inputId} position="title">
          {title}
        </Tooltip>
      )}
    </div>
  );
};

export default WizardTextInputComponent;
